module.exports = __webpack_public_path__ + "static/media/big-logo.0610aa15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/big-logo.png
// module id = 74
// module chunks = 0